import React, { FC } from 'react';

import { useFormikContext } from 'formik';

// components
import BasicButton from '../../../../../../../components/buttons/basicButton';
import styled from 'styled-components';

// constant
import aampeTheme from '../../../../../../../constants/aampeTheme';

interface AttributePlaceholderModalProps {
    handleClose: () => void;
    isUpdating?: boolean;
}
const AttributePlaceholderModalAction: FC<AttributePlaceholderModalProps> = ({
    handleClose,
    isUpdating,
}) => {
    const { isValid, dirty } = useFormikContext();
    return (
        <ActionContainer>
            <StyledButton
                isPrimary={false}
                name="Cancel"
                action={handleClose}
            />
            <StyledButton
                isPrimary
                name={isUpdating ? 'Update' : 'Add'}
                type="submit"
                isDisabled={!isValid || !dirty}
            />
        </ActionContainer>
    );
};

const StyledButton = styled(BasicButton)({
    borderRadius: aampeTheme.borderRadius.default,
    fontWeight: 500,
    width: '100%',
    fontSize: aampeTheme.size.font.default,
    lineHeight: '18px',
    padding: aampeTheme.spacing4(3, 11),
});

const ActionContainer = styled.div({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: aampeTheme.spacing4(4),
    paddingTop: aampeTheme.spacing4(4),
});

export default AttributePlaceholderModalAction;
